import { ReviewRow, ReviewMediaRow } from '../ReviewRow/ReviewRow'
import { ButtonIcon } from 'pepsico-ds'
import { ReviewProductsTable } from '@/components/organisms'
import { Constants } from '@/utils/constants/commonConstants'
import { downloadCSVFiles } from '@/helpers/shadcn/utils'
import { TARGET_TYPES } from '@/utils/constants/saleTargetConstants'
import { useParams, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

const ReviewParentChildTab = ({ languages, salesTargetData, selectedTab, section, preRequisiteParentTabData, preRequisiteChildTabData, getFilteredProducts, getSelectedCategoryTitle = () => { } }) => {
  const { displayContent, displayContentMedia, preRequisiteParentTab, preRequisiteChildTab, formData, ruleSet } = salesTargetData;

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const urlStatus = searchParams.get('status');

  const [preRequisiteActiveParentTab, setPreRequisiteActiveParentTab] = useState(null);
  const [preRequisiteActiveChildTab, setPreRequisiteActiveChildTab] = useState(null);
  useEffect(() => {
    if (urlStatus === Constants.Draft || urlStatus === Constants.Published) {
      setPreRequisiteActiveParentTab(preRequisiteParentTabData)
      setPreRequisiteActiveChildTab(preRequisiteChildTabData);
    } else {
      setPreRequisiteActiveParentTab(preRequisiteParentTab);
      setPreRequisiteActiveChildTab(preRequisiteChildTab);
    }
    // eslint-disable-next-line
  }, [urlStatus, id]);
  const getAnswer = val => (val ? 'Yes' : 'No')
  const LanguageContent = ({ lang }) => {
    const data = selectedTab === 'parent' ? displayContent?.[lang.code] : displayContent?.child?.[lang.code]

    if (!data) return null

    return (
      <>
        <ReviewRow data-testid="display-title-label" label="Title" value={data.title} />
        <ReviewRow label="Excerpt" value={data.excerpt} />
        <ReviewRow label="Terms" value={data.terms} />
      </>
    )
  }

  const DisplayContent = () => {
    const imageUri = displayContentMedia?.imageUri || displayContentMedia?.imageUrl || '';
    return (
      <div data-testid="ReviewParentChildContent">
        <div className="review_subtitle mtb30">Display</div>
        {languages?.map(lang => (
          <div className="grid" key={lang.code}>
            <div className="grid_wrap">
              <div className="review_grid_row borderBottom0 grid grid-cols-2 gap-y-2 grid-col-temp">
                <div className="rev_lang">
                  <span>Language: </span> <span className="langBold">{lang.title}</span>
                </div>
              </div>
              <LanguageContent lang={lang} />
            </div>
          </div>
        ))}

        {imageUri && imageUri !== '' &&
          <>
            <div className="review_subtitle mtb16">Media</div>
            <div className="grid grid-cols-2">
              <div className="grid_wrap">
                <a href={imageUri} download={"display_content_image.png"} className="review_image_row grid grid-cols-2 gap-y-2 cursor-pointer" >
                  <img src={imageUri} alt="Pepsi Logo" />
                </a>
                <ReviewMediaRow data-testid="display-title-label" label="Title" value={displayContentMedia?.title} />
                <ReviewMediaRow label="Opt In" value={getAnswer(displayContentMedia?.optIn)} />
              </div>
            </div>
          </>
        }
      </div>
    )
  }

  const ProductUploadedFile = () => {
    let rule;
    let mediaFile;

    if (selectedTab === 'parent') {
      rule = salesTargetData?.tabWiseData?.parent?.ruleSet?.rules?.[0]
        || salesTargetData?.ruleSet?.rules?.[0];
      mediaFile = salesTargetData?.tabWiseData?.parent?.mediaFile?.[0];
    } else if (selectedTab === 'child') {
      rule = salesTargetData?.tabWiseData?.child?.ruleSet?.rules?.[0]
        || salesTargetData?.ruleSet?.rules?.[0];
      mediaFile = salesTargetData?.tabWiseData?.child?.mediaFile?.[0];
    } else {
      rule = salesTargetData?.ruleSet?.rules?.[0];
      mediaFile = salesTargetData?.mediaFile?.[0];
    }

    const includedProductIds = rule?.includedProductIds || [];
    const onDownloadClick = async () => {
      if (!includedProductIds.length) return; // Prevent download if empty
      const csvHeader = 'Product Id\n';
      const csvRows = includedProductIds.join('\n');
      const csvString = csvHeader + csvRows;
      downloadCSVFiles(csvString, mediaFile);
    };
    return (
      <>
        <div className="review_subtitle">Target Setup</div>
        {selectedTab === 'parent' ? <>
          <div className="grid grid-cols-2 gap-8">
            <div className="grid grid-cols-1 ">
              <div className="grid_wrap">
                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                  <div className="review_title">
                    <span>Ignore SKU List</span>
                  </div>
                  <div className="review_value text-white">
                    <span>{getAnswer(formData?.isSKUList)}</span>
                  </div>
                </div>
                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                  <div className="review_title">
                    <span>Product Selection</span>
                  </div>
                  <div className="review_value text-white">
                    <span>
                      {formData?.targetType === TARGET_TYPES.MainTarget
                        ? 'All Products Included'
                        : `yes - ${ruleSet?.rules[0]?.includedProductIds?.length}`}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 ">
              <div className="grid_wrap">
                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                  <div className="review_title">
                    <span>Category</span>
                  </div>
                  <div className="review_value text-white">
                    <span>{getSelectedCategoryTitle()}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {preRequisiteActiveParentTab?.categoryTable && <ReviewProductsTable products={getFilteredProducts('parent')} />}
          {preRequisiteActiveParentTab?.uploadFile && <>
            <div className="grid">
              <div className="grid_wrap flex flex-direction-row">
                <ReviewRow label="Product List" value={salesTargetData?.tabWiseData?.parent?.mediaFile[0]} />
                <ButtonIcon
                  icon="file_download"
                  isDark
                  onClick={onDownloadClick}
                  size="medium"
                  type="default"
                  data-testid="file_download"
                />
              </div>
            </div>
          </>}
        </> : <>
          <div className="grid grid-cols-2 gap-8">
            <div className="grid grid-cols-1 ">
              <div className="grid_wrap">
                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                  <div className="review_title">
                    <span>Ignore SKU List</span>
                  </div>
                  <div className="review_value text-white">
                    <span>{getAnswer(formData?.isSKUList)}</span>
                  </div>
                </div>
                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                  <div className="review_title">
                    <span>Product Selection</span>
                  </div>
                  <div className="review_value text-white">
                    <span>
                      {formData?.targetType === TARGET_TYPES.MainTarget
                        ? 'All Products Included'
                        : `yes - ${ruleSet?.rules[0]?.includedProductIds?.length}`}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 ">
              <div className="grid_wrap">
                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                  <div className="review_title">
                    <span>Category</span>
                  </div>
                  <div className="review_value text-white">
                    <span>{getSelectedCategoryTitle()}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {preRequisiteActiveChildTab?.categoryTable && <ReviewProductsTable products={getFilteredProducts('child')} />}
          {preRequisiteActiveChildTab?.uploadFile && <>
            <>
              <div className="grid">
                <div className="grid_wrap grid_wrap flex flex-direction-row">
                  <ReviewRow label="Product List" value={salesTargetData?.tabWiseData?.child?.mediaFile[0]} />
                  <div
                    className='grid_wrap review_grid_row'
                  >
                    <ButtonIcon
                      icon="file_download"
                      isDark
                      onClick={onDownloadClick}
                      size="medium"
                      type="default"
                      data-testid="file_download"
                    />
                  </div>
                </div>
              </div>
            </>
          </>}
        </>}
      </>
    )
  }
  return (
    <>
      {
        section === 'display-content' ? <DisplayContent /> : <ProductUploadedFile />
      }
    </>
  )
}

export default ReviewParentChildTab
